export default "__VITE_ASSET__aD5fSaTb__"